const funcs = {
  bind() {
    const self = this;
    this.event = (event) => {
      console.log('emitting event');
      self.vm.$emit(self.expression, event);
    };
    this.el.addEventListener('click', this.stopProp);
    this.document.body.addEventListener('click', this.event);
  },

  unbind() {
    this.el.removeEventListener('click', this.stopProp);
    document.body.removeEventListener('click', this.event);
  },

  stopProp(event) { event.stopPropagation(); },
};

export default funcs;



// WEBPACK FOOTER //
// ./src/directives/click-outside.js